export { LanguageSwitcher } from "./LanguageSwitcher";
export { LocaleFlag } from "./LocaleFlag";
export type {
  LanguageSwitcherProps,
  LanguageSwitcherVariant,
  LocaleFlagProps,
} from "./LanguageSwitcher.types";
